import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, money, imgSrc } from "../../lib/api";
import { ProductForm } from "./ProductForm";

export const ProductsAdmin = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/products").then((r) => setItems(Array.isArray(r.data) ? r.data : []));
  useEffect(() => { load(); }, []);

  const remove = async (p) => {
    if (!window.confirm(`Delete ${p.title}?`)) return;
    try { await api.delete(`/admin/products/${p.id}`); toast.success("Deleted"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <button onClick={() => setEditing({})} data-testid="admin-add-product-button" className="btn-primary mb-6"><Plus className="h-4 w-4" /> Add product</button>
      <div className="space-y-3">
        {items.map((p) => (
          <div key={p.id} data-testid={`admin-product-row-${p.id}`} className="flex items-center gap-4 rounded-2xl border border-white/[0.07] bg-[#1a1633] p-3">
            <img src={imgSrc(p.image)} alt="" className="h-14 w-20 shrink-0 rounded-lg object-cover" />
            <div className="min-w-0 flex-1">
              <div className="truncate font-display uppercase text-white">{p.title}</div>
              <div className="text-sm text-zinc-400">{money(p.price)} · {p.stock} in stock · {p.badge}</div>
            </div>
            <button onClick={() => setEditing(p)} data-testid={`admin-edit-${p.id}`} className="rounded-lg p-2 text-zinc-300 hover:bg-white/5"><Pencil className="h-4 w-4" /></button>
            <button onClick={() => remove(p)} data-testid={`admin-delete-${p.id}`} className="rounded-lg p-2 text-rose-400 hover:bg-white/5"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      {editing && <ProductForm product={editing} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
    </div>
  );
};
